var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foo"},[_c('site-header'),_c('div',{staticClass:"row banner"},[_c('div',{staticClass:"col s11 offset-s1"},[_c('router-link',{attrs:{"to":"/educator"}},[_c('h4',[_vm._v(" Educator Portal")])])],1)]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }